import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "lpu-card-skeleton",
      attrs: { "data-qa": "lpu_card_skeleton" },
    },
    [
      _c(VSkeletonLoader, {
        staticClass: "lpu-card-skeleton__profile",
        attrs: { type: "avatar,article" },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "lpu-card-skeleton__contact-list" },
        _vm._l(5, function (i) {
          return _c(VSkeletonLoader, { key: i, attrs: { type: "text@3" } })
        }),
        1
      ),
      _vm._v(" "),
      _c(VSkeletonLoader, {
        staticClass: "lpu-card-skeleton__select",
        attrs: { type: "text" },
      }),
      _vm._v(" "),
      _c(VSkeletonLoader, {
        staticClass: "lpu-card-skeleton__calendar-title",
        attrs: { type: "text@3" },
      }),
      _vm._v(" "),
      _c(VSkeletonLoader, {
        staticClass: "lpu-card-skeleton__calendar",
        attrs: { type: "text@4" },
      }),
      _vm._v(" "),
      _c(VSkeletonLoader, {
        staticClass: "lpu-card-skeleton__description",
        attrs: { type: "text@4" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }